// 报销申请dlg组件

const onReimburseApplyDlg = {
  namespaced: true,

  state: {
    dlgShow: false,
  },

  getters: {
    dlgShow: state => state.dlgShow,
  },

  mutations: {
    SET_DLGSHOW: (state, val) => {
      state.dlgShow = val
    },
  },

  actions: {

  }
}

export default onReimburseApplyDlg
